import { type TextareaHTMLAttributes, forwardRef, useId } from "react";
import { cn } from "../../lib/utils.ts";

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ label, error, className, id, ...props }, ref) {
    const reactId = useId();
    const labelSlug = label?.toLowerCase().replace(/\s+/g, "-");
    const textareaId = id || (labelSlug ? `${labelSlug}-${reactId}` : reactId);

    return (
      <div className="flex flex-col gap-1.5">
        {label && (
          <label
            htmlFor={textareaId}
            className="text-sm font-medium text-slate-700"
          >
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={textareaId}
          className={cn(
            "w-full rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-sm shadow-sm",
            "placeholder:text-slate-400",
            "focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-100",
            "disabled:bg-slate-50 disabled:text-slate-400",
            error && "border-error focus:border-error focus:ring-error",
            className,
          )}
          {...props}
        />
        {error && <p className="text-xs text-error">{error}</p>}
      </div>
    );
  },
);
